// CustomAmountFilter.js
import React, { useState } from 'react';
import { HiEllipsisHorizontal } from 'react-icons/hi2';

const CustomAmountFilter = ({ column: { filterValue = [], setFilter } }) => {
  const [minAmount, setMinAmount] = useState(filterValue[0] || '');
  const [maxAmount, setMaxAmount] = useState(filterValue[1] || '');

  const onMinAmountChange = (e) => {
    const value = e.target.value;
    setMinAmount(value);
    setFilter([value || undefined, maxAmount || undefined]);
  };

  const onMaxAmountChange = (e) => {
    const value = e.target.value;
    setMaxAmount(value);
    setFilter([minAmount || undefined, value || undefined]);
  };

  return (
    <div className="input-group">
        <div className="input-range input-group">
            <input
                type="number"
                value={minAmount}
                onChange={onMinAmountChange}
                placeholder="Min Amount"
                className="form-control"
            />
            <div className="input-group-append">
                <span className="input-group-text">
                    <HiEllipsisHorizontal />
                </span>
            </div>
            <input
                type="number"
                value={maxAmount}
                onChange={onMaxAmountChange}
                placeholder="Max Amount"
                className="form-control"
            />
        </div>
    </div>
  );
};

export default CustomAmountFilter;
